import translations from './translations'

translations.add('en', {
    copied: 'Copied'
})
